import { message } from "antd";

export class SearchManager {
  constructor(preTag = "") {
    this.orderRefs = {};
    this.orderPreTag = preTag;
    this.activeTab = "";
    this.previousHighlight = null; 
  }

  clearPreviousHighlight = () => {
    // console.log("clear highlight call")
    if (this.previousHighlight) {
      this.previousHighlight.style.backgroundColor = "";
      this.previousHighlight = null;
    }
  };

performSearch = (type, searchValue, sort) => {


  let searchKey = searchValue.toLowerCase();

  if (type === "orderId" && this.orderPreTag) {
    const lowerPreTag = this.orderPreTag.toLowerCase();
    if (!searchKey.includes(lowerPreTag)) {
      searchKey = `${lowerPreTag}${searchKey}`;
    }
  }

  // console.log(searchKey, "searchkey")

  let selector = "";
  switch (type) {
    case "orderId":
      selector = `[data-order-id="${searchKey}"]`;
      break;
    case "tableName":
      selector = `[data-table-name="${searchKey}"]`;
      break;
    case "tokenNumber":
      selector = `[data-token-id="${searchKey}"]`;
      break;
    default:
      message.error("Invalid search type");
      return;
  }

  // console.log("Searching with selector:", selector);

  // Get all matching elements
  const allElements = Array.from(document.querySelectorAll(selector));

  // Filter only elements that are still connected to the DOM and visible
  const elements = allElements.filter(
    el => el.isConnected && el.offsetParent !== null
  );

  // console.log(`Found ${elements.length} valid elements in DOM`);

  if (elements.length === 0) {
    message.error("No Match Found");
    return;
  }

  const targetElement = sort ? elements[0] : elements[elements.length - 1];

  targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
  targetElement.style.transition = "background-color 0.3s ease";
  targetElement.style.backgroundColor = "#ffeb3b";


  if (this.previousHighlight && this.previousHighlight !== targetElement) {
    this.previousHighlight.style.backgroundColor = "";
  }

  this.previousHighlight = targetElement;

  // console.log(`Scrolled to element: ${targetElement.id || "(no id)"}`);
};

}
